const ACADEMIC_GRADE_LEVEL = {
  AG1_LEVEL: 'Investigador Titular',
  AG2_LEVEL: 'Investigador Auxiliar',
  AG3_LEVEL: 'Investigador Adjunto',
  AG4_LEVEL: 'Aspirante',
};
/**
 * Enum definition.
 *
 * @type {string[]}
 */
const ACADEMIC_GRADE_LEVEL_ENUM = Object.keys(ACADEMIC_GRADE_LEVEL);

const AG1_LEVEL = ACADEMIC_GRADE_LEVEL_ENUM[0];
const AG2_LEVEL = ACADEMIC_GRADE_LEVEL_ENUM[1];
const AG3_LEVEL = ACADEMIC_GRADE_LEVEL_ENUM[2];
const AG4_LEVEL = ACADEMIC_GRADE_LEVEL_ENUM[3];

export {
  ACADEMIC_GRADE_LEVEL,
  ACADEMIC_GRADE_LEVEL_ENUM,
  AG1_LEVEL,
  AG2_LEVEL,
  AG3_LEVEL,
  AG4_LEVEL,
};
